import { render, staticRenderFns } from "./PersonnelList.vue?vue&type=template&id=60332d0a&scoped=true&"
import script from "./PersonnelList.vue?vue&type=script&lang=js&"
export * from "./PersonnelList.vue?vue&type=script&lang=js&"
import style0 from "./PersonnelList.vue?vue&type=style&index=0&id=60332d0a&lang=scss&scoped=true&"
import style1 from "./PersonnelList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60332d0a",
  null
  
)

export default component.exports